<template>
  <div class="container_img">
    <div class="circle">
      <img
        v-if="computedTestType == 'HSK'"
        class="circle_icon"
        src="@/assets/images/hsk/title.png"
        alt=""
      />
      <img
        v-else-if="computedTestType == 'HSKK'"
        class="circle_icon_hssk"
        src="@/assets/images/hsk/hskk_title.png"
        alt=""
      />
      <img
        v-else-if="computedTestType == 'HSK3'"
        class="circle_icon"
        src="@/assets/images/hsk/title.png"
        alt=""
      />
      <img v-else class="circle_icon_yct" src="@/assets/images/hsk/yct.png" alt="" />

    </div>
    <div v-if="computedTestType == 'HSKK'" class="circle2" :class="[!isGreenType ? 'circle2_orange' : '']">
      <div :class="[localLanguage === 'cn' ? 'circle2_level_hskk_cn' : 'circle2_level_hskk_else']">{{ appLevelName }}</div>
    </div>
    <div v-else class="circle2" :class="[!isGreenType ? 'circle2_orange' : '']">
      <div class="circle2_level">level</div>
      <div class="circle2_num" :class="[isSmlNumFont ? 'circle2_smlNum' : '']">
        {{ computedLevelIndex }}
      </div>
    </div>
    <div class="circle3">
      <BackLevel @goBackRoute="goBackRoute"></BackLevel>
    </div>


  </div>
<!--  <div>-->
<!--    -->
<!--  </div>-->
</template>
<script>
import { mapState } from 'vuex'
import { testConfig } from '@/config'
import BackLevel from '@/components/common/BackLevel.vue'
import { getRealLevelName } from '@/utils/hskTool'
import analytics from "@/utils/AnalyticsCenter";
import {mixinLanguage} from '@/mixins'
export default {
  components: {
    BackLevel,
  },
  mixins: [mixinLanguage],
  props: {
    testType: {
      default: 1,
      type: Number,
    },
    levelType: {
      default: '',
      type: String,
    },
    levelNum: {
      type: Number,
    },
    currentLevelIndex: {
      default: null,
      type: Number,
    },
    appLevelName: {
      default: '',
      type: String,
    },
  },
  computed: {
    ...mapState({
      levelActiveIndex: (state) => state.level.levelActiveIndex,
    }),
    computedTestType() {
      const compare = (a, b) => {
        return a == b
      }
      let result =
        this.levelType ||
        Object.keys(testConfig).find((item) => compare(testConfig[item], this.testType))
      console.log(testConfig,result,this.testType,this.levelType,'testConfigtestConfig')
      return result.toUpperCase()
    },
    computedLevelIndex() {
      let routerLevel = 1
      if (this.$route.query.level && this.$route.query.level.match(/\d+/)) {
        routerLevel = +this.$route.query.level.match(/\d+/)[0]
      } else if (this.$route.query.level_num) {
        routerLevel = this.$route.query.level_num
      }

      return getRealLevelName(this.computedTestType, routerLevel)

      // return Number(
      //   this.currentLevelIndex || this.levelNum || this.levelActiveIndex || localStorage.getItem("LevelActiveId"),
      // );
    },
    isSmlNumFont() {
      return this.computedTestType === 'HSK' && this.computedLevelIndex === '7-9'
    },
    isGreenType() {
      // HSK || HSKK
      return this.computedTestType.toUpperCase().includes('HSK')
    },
  },
  methods: {
    goBackRoute() {
      const params = {
        exam_type: this.levelTypeName + this.levelActiveIndex,
      }
      analytics.logEvent('hskweb_switch_click', params)
      this.$router.replace({
        name: 'ChooseLevel',
      })
    },
  }
}
</script>
<style scoped lang="scss">
.container_img {
  display: flex;
  margin-top: 30px;
  .circle {
    border-radius: 50%;
    width: 140px;
    height: 140px;
    margin-right: -20px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.07);
    z-index: 5;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding-left: 11px;
    padding-right: 11px;
    &_icon {
      width: 116px;
      height: 76px;
    }
    &_icon_hssk {
      width: 110px;
      height: 52px;
    }
    &_icon_yct {
      width: 140px;
      height: 140px;
    }
    &_middle {
      border-bottom: 3px solid #878787;
      border-top: 3px solid #878787;
      font-size: 11px;
      transform: scale(0.8);
    }
  }
  .circle2_orange {
    background: #c97026 !important;
  }
  .circle2 {
    border-radius: 50%;
    width: 140px;
    height: 140px;
    border: 4px solid white;
    box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.07);
    background: #4e8545;
    opacity: 1;
    margin-right: -20px;
    z-index: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    &_level {
      color: #fff;
      text-align: center;
      font-size: 28px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      margin-top: 15px;
    }
    &_level_hskk_cn {
      color: #fff;
      text-align: center;
      font-size: 28px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    }
    &_level_hskk_else {
      color: #fff;
      text-align: center;
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    }
    &_num {
      color: #fff;
      text-align: center;
      font-size: 70px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      margin-top: -9px;
    }
    &_smlNum {
      font-size: 50px;
      line-height: 75px;
      height: 87px;
    }
  }
  .circle3 {
    border-radius: 50%;
    width: 140px;
    height: 140px;
    margin-right: -20px;

    z-index: 5;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding-left: 11px;
    padding-right: 11px;
    &_icon {
      width: 116px;
      height: 76px;
    }
    &_icon_hssk {
      width: 110px;
      height: 52px;
    }
    &_icon_yct {
      width: 140px;
      height: 140px;
    }
    &_middle {
      border-bottom: 3px solid #878787;
      border-top: 3px solid #878787;
      font-size: 11px;
      transform: scale(0.8);
    }
  }

  @media screen and (max-width: 768px) {
    width: 95%;
    height: auto;
    margin-left: auto;
    margin-right: auto;

    .circle3 {
      width: 130px;
      height: 130px;
    }

    .circle {
      position: relative;
      top: -2px;
    }

  }
}
</style>
